import React from 'react'
import { IListItem } from '../../../types/interfaces'

// assets
import { ReactComponent as HeadingIcon } from '../../../assets/icons/ElementIcons/heading-icon.svg'
import { ReactComponent as CheckBoxIcon } from '../../../assets/icons/ElementIcons/checkbox-icon.svg'
import { ReactComponent as DropDownIcon } from '../../../assets/icons/ElementIcons/dropdown-icon.svg'
import { ReactComponent as InputIcon } from '../../../assets/icons/ElementIcons/input-icon.svg'
import { ReactComponent as RadioIcon } from '../../../assets/icons/ElementIcons/radio-icon.svg'
import { ReactComponent as TextareaIcon } from '../../../assets/icons/ElementIcons/textarea-icon.svg'
import { ReactComponent as ButtonIcon } from '../../../assets/icons/ElementIcons/button-icon.svg'
import { ReactComponent as TextIcon } from '../../../assets/icons/ElementIcons/text-icon.svg'
import { ReactComponent as TableIcon } from '../../../assets/icons/ElementIcons/table-icon.svg'
import { ReactComponent as HorizontalLineIcon } from '../../../assets/icons/ElementIcons/horizontal-line-icon.svg'
import { ReactComponent as DateIcon } from '../../../assets/icons/ElementIcons/date-icon.svg'
import { ReactComponent as TabIcon } from '../../../assets/icons/ElementIcons/section-icon.svg'
import { ReactComponent as ImageIcon } from '../../../assets/icons/ElementIcons/image-icon.svg'
import { ReactComponent as SelectFromTableIcon } from '../../../assets/icons/ElementIcons/webview-icon.svg'

// utils
import { ELEMENT_TYPES, OBJECTS } from '../../../utils/enums'

const elementsList: IListItem[] = [
	{
		key: ELEMENT_TYPES.TEXT,
		label: 'Paragraph',
		description: 'Single line or multiline text label',
		icon: <TextIcon />
	},
	{
		key: ELEMENT_TYPES.INPUT,
		label: 'Input',
		description: 'Single line input field',
		icon: <InputIcon />
	},
	{
		key: ELEMENT_TYPES.DROPDOWN_BUTTON,
		label: 'Dropdown button',
		description: 'Button with dropdown options',
		icon: <DropDownIcon />
	},
	{
		key: ELEMENT_TYPES.CHECK_BOX,
		label: 'Checkbox',
		description: 'Select multiple items',
		icon: <CheckBoxIcon />
	},
	{
		key: ELEMENT_TYPES.RADIO_BUTTON,
		label: 'Radio button',
		description: 'Select only one item from list',
		icon: <RadioIcon />
	},
	{
		key: ELEMENT_TYPES.TEXT_AREA,
		label: 'Textarea',
		description: 'Unlimited text input',
		icon: <TextareaIcon />
	},
	{
		key: ELEMENT_TYPES.HORIZONTAL_LINE,
		label: 'Horizontal line',
		description: 'Divider line',
		icon: <HorizontalLineIcon />
	},
	{
		key: ELEMENT_TYPES.DATE_PICKER,
		label: 'Date',
		description: 'Select date and time',
		icon: <DateIcon />
	},
	{
		key: ELEMENT_TYPES.BUTTON,
		label: 'Button',
		description: 'Single button',
		icon: <ButtonIcon />
	},
	{
		key: ELEMENT_TYPES.TABLE,
		label: 'Table',
		description: 'Multirow and multicolumn table',
		icon: <TableIcon />
	},
	{
		key: ELEMENT_TYPES.TITLE,
		label: 'Title',
		description: 'Single line or multiline heading',
		icon: <HeadingIcon />
	},
	{
		key: ELEMENT_TYPES.IMAGE,
		label: 'Image',
		description: 'Show image for operators',
		icon: <ImageIcon />
	},
	{
		key: ELEMENT_TYPES.SELECT_FROM_TABLE,
		label: 'Select from table',
		description: 'Embed table select',
		icon: <SelectFromTableIcon />
	},
	{
		key: ELEMENT_TYPES.TAB_BOX,
		label: 'Tabs',
		description: 'Organize content in tabs',
		icon: <TabIcon />
	}
]

export const objectList = [
	{
		key: OBJECTS.OBJECT_STATUS,
		label: 'Status object',
		description: 'Date & dropdown & button'
	}
]

export default elementsList
